/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {VoucherService} from '../vouchers-services/vouchers.service';
import {VendorService} from 'src/app/custom/vendor/vendor.service';
import * as moment from 'moment';
import {Query, Voucher} from 'src/generated/graphql';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {vendorNode} from 'src/app/custom/vendor/vendor-model';
import {VendorTypes, VoucherPortabilityTypes} from 'src/app/custom/housing-core/services/housing-models';
import {Observable} from 'rxjs';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import { FormControl } from '@angular/forms';

interface emitPortOutAction {
  enablePortOut: boolean;
}
interface emitDisableNextPortVendor {
  disableNextForPortabilityVendor: boolean;
}

@Component({
  selector: 'app-vouchers-moveout',
  templateUrl: './vouchers-moveout.component.html',
  styleUrls: ['./vouchers-moveout.component.scss'],
})
export class VouchersMoveOutComponent implements OnInit {
  customerId: string;
  siteId: string;
  @Input() data: any;
  @Output() emitPortOutAction = new EventEmitter<emitPortOutAction>();
  @Output() emitDisableNextPortVendor = new EventEmitter<emitDisableNextPortVendor>();
  loggedInUser: string;
  voucher: Voucher;
  activeVoucher = false;
  observable: any;
  voucherStatusList = [
    {name: 'Terminated', value: 'TERMINATED'},
    {name: 'Issued', value: 'ISSUED'},
    {name: 'Shop Mode', value: 'SHOP_MODE'},
    {name: 'Port Out', value: 'PORT_OUT'},
  ];
  voucherstatus: any = this.voucherStatusList[0];
  currentVoucher: Voucher;
  voucherCheck: boolean;
  spinnerCheck: boolean;
  selectedAuthorityId: string;
  selectedAuthorityName: string;
  selectedVendor: vendorNode;
  filteredVendors$: Observable<vendorNode[]>;
  vendorCtrl = new FormControl('');
  private CUSTOMER_ID = sessionStorage.getItem('CUSTOMERID') || '';
  private SITE_ID = sessionStorage.getItem('SITEID') || '';

  constructor(private voucherService: VoucherService, private vendorService: VendorService) {}

  ngOnDestroy() {
    //Service takes voucherStatus for the final page's voucher update.
    if (this.data.step != 'review') {
      this.voucherService.setActionItems([this.voucherstatus, this.selectedAuthorityId, this.selectedAuthorityName]);
    } else {
      this.voucherService.setActionItems(null); //Setting service item to null so it will not carry over to different households or actions
    }
  }

  ngOnInit() {
    this.customerId = this.CUSTOMER_ID;
    this.siteId = this.SITE_ID;
    this.spinnerCheck = true;
    // Saving to a Service item due to selection being on 2nd/date step but the voucher update needs to happen on the 4th/review step
    const serviceArray = this.voucherService.loadActionItems();
    const selectedStatus = serviceArray && serviceArray.length > 0 ? serviceArray[0] : null;
    const selectedAuthorityId = serviceArray && serviceArray.length > 1 ? serviceArray[1] : null;
    this.filteredVendors$ = this.vendorCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      switchMap((value: string) => this.vendorService.getVendorsV2(50, '', 'forward', value, VendorTypes.Housingauthority))
    );
    this.getCurrentUsersLogInCookie();
    this.observable = this.voucherService.getVoucherByHouseHoldIdTrimmed(this.data.householdId).subscribe(
      (result: any) => {
        const query: Query = result?.data;
        if (query.vouchers.edges.length > 0) {
          const finder = query.vouchers.edges.find(edge => edge.node.state === 'LEASED');
          if (finder) {
            this.voucher = finder.node;
            if (this.voucher) {
              this.voucherCheck = true;
              this.spinnerCheck = false;
              this.checkPortOutSettings();
              if (this.data.step === 'review') {
                const isPortOut = selectedStatus.value === 'PORT_OUT';
                const voucherCommand = {
                  voucherId: this.voucher.id,
                  customerId: this.customerId,
                  siteId: this.siteId,
                  modifiedBy: this.loggedInUser,
                  movedOutOn: moment(this.data.effectiveDate).format('MM-DD-YYYY'),
                  terminatedOn: null,
                  newState: selectedStatus.value,
                  effectiveDate: moment(this.data.effectiveDate).format('MM-DD-YYYY'),
                };
                if (selectedStatus.value === 'TERMINATED') {
                  voucherCommand.terminatedOn = moment(new Date()).format('MM-DD-YYYY');
                }
                const newExpirationDate = moment(this.data.effectiveDate).add(60, 'days');
                const command2 = {
                  voucherId: this.voucher.id,
                  fundingProgramId: this.voucher.program.id,
                  fundingProjectId: this.voucher.project.id,
                  customerId: this.voucher.customerId,
                  siteId: this.voucher.siteId,
                  voucherNumber: this.voucher.voucherNumber,
                  expiresOn: moment(newExpirationDate).format('MM-DD-YYYY'),
                  modifiedBy: this.loggedInUser ? this.loggedInUser : 'voucher form', //we need to save the user in cookies or session storage to pull this value
                  unitId: this.voucher?.unitId ? this.voucher?.unitId : null,
                  portabilityType: isPortOut ? VoucherPortabilityTypes.PortOut : this.voucher?.portabilityType,
                  portabilityVendor: isPortOut ? selectedAuthorityId : this.voucher?.portabilityVendor,
                };
                this.voucherService.changeVoucherStatus(voucherCommand).subscribe(
                  (results: any) => {
                    this.voucherService.editVoucher(command2).subscribe(
                      (results2: any) => {},
                      error => {
                        console.log('There was an error updating voucher expiration date', error);
                      }
                    );
                  },
                  error => {
                    console.log('There was an error sending the voucher transition', error);
                  }
                );
              }
              else {
                this.checkVoucherType();
              }
            } else {
              this.spinnerCheck = false;
            }
          } else {
            this.spinnerCheck = false;
          }
        }
        this.spinnerCheck = false;
      },
      error => {
        this.spinnerCheck = false;
      }
    );
  }

  getCurrentUsersLogInCookie() {
    const cookies = document.cookie.split(';');
    let usersAuthCookie;
    for (const cookie of cookies) {
      if (cookie.includes('LastAuthUser')) {
        //found the cookie of the user
        usersAuthCookie = cookie;
      }
    }
    const arrayOfCookieStrings = usersAuthCookie.split('=');
    this.loggedInUser = arrayOfCookieStrings[1];
  }

  checkVoucherType() {
    if (this.voucher.voucherType != "TENANT_BASED") {
      this.voucherStatusList.pop(); // Removes Port Out status option for non Tenant Based vouchers
    }
  }

  checkPortOutSettings() {
    let tenantBasedVoucher = this.voucher.voucherType == "TENANT_BASED";
    let selectedPortOutVoucher = this.voucherstatus.value == "PORT_OUT";
    if (tenantBasedVoucher && selectedPortOutVoucher) {
      this.emitPortOutAction.emit({enablePortOut: true});
      this.emitDisableNextPortVendor.emit({disableNextForPortabilityVendor: true});
      return;
    }
    else {
      this.selectedAuthorityId = null;
      this.vendorCtrl.reset();
      this.emitDisableNextPortVendor.emit({disableNextForPortabilityVendor: false});
      this.emitPortOutAction.emit({enablePortOut: false});
    }
  }

  onVendorSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedVendor = event.option.value;
    this.selectedAuthorityId = this.selectedVendor.id;
    this.selectedAuthorityName = this.selectedVendor.name;
    this.emitDisableNextPortVendor.emit({disableNextForPortabilityVendor: false});
  }

  vendorSelectDisplay(option: vendorNode): string {
    return option?.name || '';
  }
}
